import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';
import BGVideo from '../layout/BGVideo';

class ScrollItem__Text extends VScroll_Item {
  timeline;
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.counter = GetBy.class("counter", this.item)[0];
    this.label = GetBy.class("label", this.item)[0];
    this.body = GetBy.class("body", this.item)[0];
    this.scrollbarFake = GetBy.class("scrollbar-fake", this.item)[0];
    this.item.style.opacity = 0;
    if(this.scrollbarFake) this.scrollbarFake.style.opacity = 1;

    this.onMove = () => {
      let alpha = 0;
      
      if(this.progress < .5) {
        alpha = Maths.normalize(0.3, 0.2, this.progress);
        this.body.style.opacity = Maths.normalize(0.4, 0.3, this.progress);
      } else {
        alpha = Maths.normalize(0.6, 0.8, this.progress);
        this.body.style.opacity = Maths.normalize(0.6, 0.7, this.progress);
      }

      if(this.counter) this.counter.style.opacity = alpha;
      if(this.label) this.label.style.opacity = alpha;
      if(this.scrollbarFake) {
        if(this.progress > .6) {
          this.scrollbarFake.style.opacity = alpha * 2;
        } else {
          this.scrollbarFake.style.opacity = 1;
        }
      }
     
    }
  }
}

Scroll._registerClass('text', ScrollItem__Text);